import { createContext, useContext } from 'react';

/**
 * Shares the hierarchy expand/collapse state with every tree node so that a
 * single "expand all / collapse all" action can drive the whole tree without
 * each node keeping its own local state.
 */
export const HierarchyExpansionContext = createContext({
    isNodeExpanded: () => false,
    toggleNode: () => { },
});

/**
 * Hook for a tree node. Pass the node's unique id and get back whether it is
 * currently expanded plus a toggle handler.
 */
export const useNodeExpansion = (nodeId) => {
    const { isNodeExpanded, toggleNode } = useContext(HierarchyExpansionContext);
    return {
        expanded: isNodeExpanded(nodeId),
        toggle: () => toggleNode(nodeId),
    };
};
